export function GlassCard({ children, className = '', dark = false, onClick, testId }) {
  const base = dark
    ? 'glass-card'
    : 'glass-card-light';
  return (
    <div
      className={`${base} ${className}`}
      onClick={onClick}
      data-testid={testId}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick(e); } : undefined}
    >
      {children}
    </div>
  );
}

export function GradientCard({ children, gradient, className = '', testId }) {
  return (
    <div
      className={`glass-sheen relative overflow-hidden rounded-3xl ${className}`}
      style={{ background: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})` }}
      data-testid={testId}
    >
      <div className="relative z-[2]">{children}</div>
    </div>
  );
}
